// extracted by mini-css-extract-plugin
module.exports = {"anualReport":"VaultValuation_anualReport__28L_L"};